import React from 'react';
import ChartComponent, { Chart } from 'react-chartjs-2';
import { AutoSizer } from 'react-virtualized';

Chart.defaults.StyledLine = Chart.defaults.line;
Chart.controllers.StyledLine = class StyledLine extends Chart.controllers.line {
    constructor(chart, datasetIndex) {
        if (chart.options.print) {
            chart.options.animation = false;
        }

        //if (chart.data.datasets[datasetIndex].color === 'blue') {
        if (datasetIndex % 2 === 0) {
            chart.data.datasets[datasetIndex].borderColor = '#4886ff';
            if (!chart.options.print) {
                const gradient = chart.ctx.createLinearGradient(0, 0, 0, chart.canvas.height);
                gradient.addColorStop(0, 'rgba(72,134,255,0.25)');
                gradient.addColorStop(0.7, 'rgba(72,134,255,0.15)');
                gradient.addColorStop(1, 'rgba(72,134,255,0)');
                chart.data.datasets[datasetIndex].backgroundColor = gradient;
                chart.data.datasets[datasetIndex].shadowColor = 'rgba(72,134,255,0.25)';
            }
        //} else if (chart.data.datasets[datasetIndex].color === 'violet') {
        } else {
            chart.data.datasets[datasetIndex].borderColor = '#776feb';
            if (!chart.options.print) {
                const gradient = chart.ctx.createLinearGradient(0, 0, 0, chart.canvas.height);
                gradient.addColorStop(0, 'rgba(119,111,235,0.25)');
                gradient.addColorStop(0.7, 'rgba(119,111,235,0.15)');
                gradient.addColorStop(1, 'rgba(119,111,235,0)');
                chart.data.datasets[datasetIndex].backgroundColor = gradient;
                chart.data.datasets[datasetIndex].shadowColor = 'rgba(119,111,235,0.25)';
            }
        }
        chart.data.datasets[datasetIndex].fill = !chart.options.print;
        chart.data.datasets[datasetIndex].radius = 0;
        chart.data.datasets[datasetIndex].pointHitRadius = 10;
        chart.data.datasets[datasetIndex].tension = 0;

        super(chart, datasetIndex);

        const origDraw = this.getMeta().dataset.draw;
        this.getMeta().dataset.draw = (...args) => {
            chart.ctx.save();
            if (chart.data.datasets[datasetIndex].shadowColor) {
                chart.ctx.shadowColor = chart.data.datasets[datasetIndex].shadowColor;
                chart.ctx.shadowOffsetX = 0;
                chart.ctx.shadowOffsetY = 15;
            }
            origDraw.apply(this.getMeta().dataset, args);
            chart.ctx.restore();
        }
	}
}

class StyledLineChart extends React.Component {
    render() {
        if (!this.props.data)
            return null;

        return (
            <AutoSizer disableHeight={!!this.props.height}>
                {({ width, height }) => (
                    <div className="styledWrapper__decorated-shifted" style={{ width, height }}>
                        <ChartComponent type="StyledLine"
                                        options={this.props.options}
                                        data={this.props.data}
                                        width={width}
                                        height={height || this.props.height}
                                        redraw />
                    </div>
                )}
            </AutoSizer>
        );
    }
}

export const _Chart = Chart;
export default StyledLineChart;
